import { Feature, Geometry } from 'geojson';
import {
  FenceType,
  GeofenceProperties,
  GeofenceTypeV2,
  useGetGeofencesGeoJsonQuery,
} from '@casops/store/apis/geofencesApi';
import GeofenceTooltipController from '../../tooltips/geofence-tooltip/GeofenceTooltipController';
import GeofenceLayerGroupV3 from '../geofence-layer-group/GeofenceLayerGroupV3';
import { GeofenceTooltipContextProvider } from '../geofence-layer-group/GeofenceTooltipContextProvider';

const filterFns = {
  [FenceType.Standard]: (feature: Feature<Geometry, GeofenceProperties>) =>
    feature.properties.fenceType === FenceType.Standard,
  [GeofenceTypeV2.Intersection]: (feature: Feature<Geometry, GeofenceProperties>) =>
    feature.properties.fenceType === FenceType.Intersection,
  [GeofenceTypeV2.WetRoad]: (feature: Feature<Geometry, GeofenceProperties>) =>
    feature.properties.fenceType === FenceType.WetRoad,
};

const layers = [
  {
    key: 'geo-standard',
    layerNameTrans: 'StandardGeofences',
    filter: filterFns[FenceType.Standard],
  },
  {
    key: 'geo-intersections',
    layerNameTrans: 'IntersectionGeofences',
    filter: filterFns[GeofenceTypeV2.Intersection],
  },
  {
    key: 'geo-wetroad',
    layerNameTrans: 'WetRoadGeofences',
    filter: filterFns[GeofenceTypeV2.WetRoad],
  },
];

interface AssetDetailsGeofencesLayerProps {
  checked?: boolean;
}

export function AssetDetailsGeofencesLayer({ checked = true }: AssetDetailsGeofencesLayerProps) {
  const { data: geoJson } = useGetGeofencesGeoJsonQuery(undefined, {
    refetchOnMountOrArgChange: 1800,
  });

  if (!geoJson) return null;

  return (
    <>
      {layers.map(({ key, layerNameTrans, filter }) => (
        <GeofenceTooltipContextProvider key={key}>
          <GeofenceLayerGroupV3
            key={key}
            layerNameTrans={layerNameTrans}
            checked={checked}
            geoJson={geoJson}
            filter={filter}
          >
            <GeofenceTooltipController />
          </GeofenceLayerGroupV3>
        </GeofenceTooltipContextProvider>
      ))}
    </>
  );
}

export default AssetDetailsGeofencesLayer;
